import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
    isMultiYear,
    isOtpEnabled,
    isRegisterationForthName,
    isRegisterationMiddleName,
    isRegisterByDepartments,
    loginPageColor,
    registerPageColor,
    registerPageIcon,
} from "../services/defaultSettings";

import AuthContext from "../context/AuthContext";

import auth from "../services/authServices";
import http from "../services/httpServices";
import modal from "../services/modalServices";
import page from "../services/pageServices";
import { years } from "../services/yearSevices";
import { handleFormErrors, handleFormSubmit, handleInputChange } from "../services/formServices";

import SigningForm from "../components/form/singingForm/SigningForm";
import InputField from "../components/form/elements/InputField";
import InputIcon from "../components/form/elements/InputIcon";

import registerPicture from "../assets/telawah-assets/register.jpg";
import a from "../services/analyticsServices";
import OtpComponent from "./OtpComponent";
import { useLanguage } from "../context/LanguageContext";
import { unset } from "lodash";

const Register = () => {
    const { language } = useLanguage();
    const content = {
        title: {
            en: "Create Your Account Now:",
            ar: "انشئ حسابك الآن :",
            de: "Erstellen Sie jetzt Ihr Konto:",
        },
        description: {
            en: "Enter your details correctly to get the best experience on the site.",
            ar: "ادخل بياناتك بشكل صحيح للحصول علي افضل تجربة داخل الموقع",
            de: "Geben Sie Ihre Daten korrekt ein, um die beste Erfahrung auf der Website zu erhalten.",
        },
        buttonTitle: {
            en: "Create Account",
            ar: "انشئ الحساب !",
            de: "Konto erstellen",
        },
        alt: {
            en: "Already have an account?",
            ar: "يوجد لديك حساب بالفعل؟",
            de: "Haben Sie bereits ein Konto?",
        },
        altColored: {
            en: "Login to your account now!",
            ar: "ادخل إلى حسابك الآن !",
            de: "Melden Sie sich jetzt in Ihrem Konto an!",
        },
        placeholders: {
            firstName: {
                en: "First Name",
                ar: "الاسم الأول",
                de: "Vorname",
            },
            middleName: {
                en: `${!isRegisterationForthName ? "Middle" : "Second"} Name`,
                ar: `الاسم ${!isRegisterationForthName ? "الأوسط" : "الثاني"}`,
                de: `${!isRegisterationForthName ? "Zweiter" : "Dritter"} Name`,
            },
            lastName: {
                en: "Last Name",
                ar: "الاسم الأخير",
                de: "Nachname",
            },
            phone: {
                en: "Phone Number",
                ar: "رقم الهاتف",
                de: "Telefonnummer",
            },
            fatherPhone: {
                en: "Father's Phone Number",
                ar: "رقم هاتف ولي الأمر",
                de: "Telefonnummer des Vaters",
            },
            government: {
                en: "Select Your Governorate",
                ar: "اختر محافظتك",
                de: "Wählen Sie Ihr Bundesland",
            },
            year: {
                en: "Select Your Academic Year",
                ar: "اختر الصف الدراسي",
                de: "Wählen Sie Ihr Schuljahr",
            },
            department: {
                en: "Select Your Department",
                ar: "اختر الشعبة الدراسية",
                de: "Wählen Sie Ihre Abteilung",
            },
            email: {
                en: "Email",
                ar: "البريد الإلكتروني",
                de: "E-Mail",
            },
            password: {
                en: "Password",
                ar: "كلمة السر",
                de: "Passwort",
            },
            passwordConfirm: {
                en: "Confirm Password",
                ar: "تأكيد كلمة السر",
                de: "Passwort bestätigen",
            },
        },
    };

    const [governments, setGovernments] = useState([]);
    const [departments, setDepartments] = useState([]);

    const [user, setUser] = useState({
        first_name: "",
        middle_name: "",
        third_name: "",
        last_name: "",
        phone: "",
        father_phone: "",
        government_id: "",
        department_id: "",
        year: 3,
        email: "",
        password: "",
        password_confirmation: "",
        new_phone: "",
        otp: "",
    });
    const [errors, setErrors] = useState({});
    const [isOtp, setisOtp] = useState(false);
    const [showChangePhone, setShowChangePhone] = useState(true);

    const [isLoading, setIsLoading] = useState(false);

    const { setUser: authUser } = useContext(AuthContext);
    const getDepartments = async () => {
        const token = auth.getToken();
        const config = auth.getAuthConfig(token);
        const { data } = await http.get(`api/years/${user.year}/departments/options`, config);
        console.log(user.year);
        setDepartments([]);
        if (data.length < 1) {
            setUser({ ...user, department_id: 0 });
        } else {
            setUser({ ...user, department_id: data[0]["value"] });
        }
        setDepartments(data);
    };

    useEffect(() => {
        if (user.year && user.year > 0) {
            setDepartments([]);
            getDepartments();
        }
        // eslint-disable-next-line no-undef
    }, [user.year]);
    async function getGovernments() {
        const { data } = await http.get("/api/governments");
        setGovernments(data);
        user["government_id"] = data[0]["value"];
        setUser(user);
    }
    useEffect(() => {
        getGovernments();
        const currentTitle = page.getCurrentTitle();
        page.setTitle("انشاء حساب");
        return () => {
            page.setTitle(currentTitle);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let inputFields = [
        {
            id: "first_name",
            placeholder: content.placeholders.firstName[language],
            icon: <InputIcon icon="icon-park-solid:edit-name" />,
        },
    ];
    if (isRegisterationMiddleName) {
        inputFields = [
            ...inputFields,
            {
                id: "middle_name",
                placeholder: content.placeholders.middleName[language],
                icon: <InputIcon icon="icon-park-solid:edit-name" />,
            },
        ];
    }
    if (isRegisterationForthName) {
        inputFields = [
            ...inputFields,
            {
                id: "third_name",
                placeholder: `الاسم الثالث`,
                icon: <InputIcon icon="icon-park-solid:edit-name" />,
            },
        ];
    }
    inputFields = [
        ...inputFields,
        {
            id: "last_name",
            placeholder: content.placeholders.lastName[language],
            icon: <InputIcon icon="icon-park-solid:edit-name" />,
        },
        {
            id: "phone",
            placeholder: content.placeholders.phone[language],
            icon: <InputIcon icon="ant-design:phone-filled" />,
        },
    ];
    inputFields = [
        ...inputFields,
        {
            id: "father_phone",
            placeholder: content.placeholders.fatherPhone[language],
            icon: <InputIcon icon="ant-design:phone-filled" />,
            isRequired: false,
        },
        {
            id: "government_id",
            placeholder: content.placeholders.government[language],
            type: "select",
            options: governments,

            className: "lg:col-span-2",
        },
    ];
    if (isMultiYear) {
        inputFields = [
            ...inputFields,
            {
                id: "year",
                placeholder: "اختر الصف الدراسي",
                type: "select",
                options: years,

                className: "lg:col-span-2",
            },
        ];
    }

    if (isRegisterByDepartments) {
        inputFields = [
            ...inputFields,
            {
                id: "department_id",
                placeholder: "اختر الشعبة الدراسية",
                type: "select",
                options: departments,
                className: "lg:col-span-2",
            },
        ];
    }
    inputFields = [
        ...inputFields,
        {
            id: "email",
            placeholder: content.placeholders.email[language],
            icon: <InputIcon icon="bx:at" />,
            className: "lg:col-span-2",
        },
        {
            id: "password",
            placeholder: content.placeholders.password[language],
            icon: <InputIcon icon="ri:lock-password-fill" />,
        },
        {
            id: "password_confirmation",
            placeholder: content.placeholders.passwordConfirm[language],
            icon: <InputIcon icon="ri:lock-password-fill" />,
        },
    ];

    const handleSubmit = (e) => {
        handleFormSubmit(e, setIsLoading, setErrors, registerUser);
    };

    const navigate = useNavigate();

    const { state } = useLocation();

    const redirect = () => {
        if (!state) {
            navigate("/home");
        } else {
            navigate(state.prevPath);
        }
    };
    const registerUser = async () => {
        try {
            await http.get("/sanctum/csrf-cookie");
            const visitorVisitId = a.getVisitorVisit();
            const toSendUser = { ...user, visitor_visit_id: visitorVisitId };
            toSendUser["phone"] = parseInt(user["phone"]);
            if (user["father_phone"]) {
                toSendUser["father_phone"] = parseInt(user["father_phone"]);
            }
            const result = await http.post("api/auth/register", toSendUser);
            if (isOtpEnabled && !result.data.is_code) {
                setisOtp(true);
                setShowChangePhone(true);
            } else {
                auth.authenticate(result.data.token, result.data.user);
                authUser({
                    ...result.data.user,
                });
                setIsLoading(false);
                modal.message({
                    title:
                        language === "en"
                            ? "Account created successfully!"
                            : "تم انشاء حسابك بنجاح!",
                    text: language === "en" ? "Click OK to continue" : "اضغط حسنًا للإستمرار",
                    callback: redirect,
                });
            }
        } catch ({ response }) {
            handleFormErrors(response, setIsLoading, setErrors);
        }
    };

    return (
        <div className={`space-y-6 negative-nav-margin ${language !== "ar" ? "en" : ""}`}>
            <OtpComponent
                isOtp={isOtp}
                showChangePhone={showChangePhone}
                setShowChangePhone={setShowChangePhone}
                data={user}
                setData={setUser}
                errors={errors}
                setErrors={setErrors}
            />
            <SigningForm
                className={`space-y-6 ${language === "en" ? "en" : ""}`}
                headTitle={content.title[language]}
                description={content.description[language]}
                headIcon={registerPageIcon}
                picture={registerPicture}
                layout="Glassmorphism"
                onSubmit={handleSubmit}
                fields={
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-6">
                        {inputFields.map((input, index) => {
                            return (
                                <InputField
                                    className={`${language === "en" ? "en" : ""}`}
                                    key={index}
                                    onChange={handleInputChange}
                                    data={user}
                                    setData={setUser}
                                    errors={errors}
                                    {...input}
                                />
                            );
                        })}
                    </div>
                }
                color={registerPageColor}
                secondaryColor={loginPageColor}
                buttonTitle={content.buttonTitle[language]}
                isLoading={isLoading}
                altLink={"/login"}
                alt={content.alt[language]}
                altColored={content.altColored[language]}
            />
        </div>
    );
};

export default Register;
